import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6141e82d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-play-msg-box-wrap" }
const _hoisted_2 = { class: "game-play-msgbox-title-wrap" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "msgbox-body-wrap" }
const _hoisted_5 = { class: "play-mode-list" }
const _hoisted_6 = { class: "play-mode-grid classic" }
const _hoisted_7 = { class: "grid-row cols-3 c1" }
const _hoisted_8 = { class: "grid-cell blue" }
const _hoisted_9 = { class: "cell-label" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:11", -1))
const _hoisted_11 = { class: "grid-cell green" }
const _hoisted_12 = { class: "cell-label" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:8", -1))
const _hoisted_14 = { class: "grid-cell red" }
const _hoisted_15 = { class: "cell-label" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:11", -1))
const _hoisted_17 = { class: "grid-row cols-2 c2" }
const _hoisted_18 = { class: "grid-cell blue" }
const _hoisted_19 = { class: "cell-label" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:1", -1))
const _hoisted_21 = { class: "grid-cell red" }
const _hoisted_22 = { class: "cell-label" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:0.95", -1))
const _hoisted_24 = { class: "play-mode-meta" }
const _hoisted_25 = { class: "play-mode-label" }
const _hoisted_26 = { class: "play-mode-grid special" }
const _hoisted_27 = { class: "grid-row cols-4 c3" }
const _hoisted_28 = { class: "grid-cell blue" }
const _hoisted_29 = { class: "cell-label" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:25", -1))
const _hoisted_31 = { class: "grid-cell gold" }
const _hoisted_32 = { class: "cell-label" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:22", -1))
const _hoisted_34 = { class: "grid-cell gold" }
const _hoisted_35 = { class: "cell-label" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:50", -1))
const _hoisted_37 = { class: "grid-cell red" }
const _hoisted_38 = { class: "cell-label" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:40", -1))
const _hoisted_40 = { class: "grid-row cols-3 c4" }
const _hoisted_41 = { class: "grid-cell blue" }
const _hoisted_42 = { class: "cell-label" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:11", -1))
const _hoisted_44 = { class: "grid-cell green" }
const _hoisted_45 = { class: "cell-label" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:8", -1))
const _hoisted_47 = { class: "grid-cell red" }
const _hoisted_48 = { class: "cell-label" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:11", -1))
const _hoisted_50 = { class: "grid-row cols-3 c5" }
const _hoisted_51 = { class: "grid-cell blue" }
const _hoisted_52 = { class: "cell-label" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:1", -1))
const _hoisted_54 = { class: "grid-cell gold" }
const _hoisted_55 = { class: "cell-label" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:12", -1))
const _hoisted_57 = { class: "grid-cell red" }
const _hoisted_58 = { class: "cell-label" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:0.95", -1))
const _hoisted_60 = { class: "play-mode-meta" }
const _hoisted_61 = { class: "play-mode-label" }
const _hoisted_62 = { class: "btn-group" }
const _hoisted_63 = {
  key: 0,
  class: "hint-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_x = _resolveComponent("icon-x")!

  return (_openBlock(), _createElementBlock("div", {
    class: "game-play-msg-box-root",
    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('dialogs.gameplay.title')), 1),
        (_ctx.highlightSwitchPlayMode)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "close-btn",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
            }, [
              _createVNode(_component_icon_x)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["play-mode-item", { active: _ctx.selectedMode === 'classic' }]),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectMode('classic')), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('game.playerpair')), 1),
                  _hoisted_10
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('game.tie')), 1),
                  _hoisted_13
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('game.bankerpair')), 1),
                  _hoisted_16
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t('game.player')), 1),
                  _hoisted_20
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('game.banker')), 1),
                  _hoisted_23
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", {
                class: _normalizeClass(["radio", {
                                selected: _ctx.selectedMode === 'classic'
                            }])
              }, null, 2),
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.t('dialogs.gameplay.classic')), 1)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["play-mode-item", { active: _ctx.selectedMode === 'special' }]),
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectMode('special')), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.t('bettype.bear8')), 1),
                  _hoisted_30
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.t('bettype.smalltiger')), 1),
                  _hoisted_33
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.t('bettype.bigtiger')), 1),
                  _hoisted_36
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.t('bettype.dragon7')), 1),
                  _hoisted_39
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.t('game.playerpair')), 1),
                  _hoisted_43
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.t('game.tie')), 1),
                  _hoisted_46
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.t('game.bankerpair')), 1),
                  _hoisted_49
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.t('game.player')), 1),
                  _hoisted_53
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.t('bettype.super6')), 1),
                  _hoisted_56
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.t('game.banker')), 1),
                  _hoisted_59
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", {
                class: _normalizeClass(["radio", {
                                selected: _ctx.selectedMode === 'special'
                            }])
              }, null, 2),
              _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.t('dialogs.gameplay.special')), 1)
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_62, [
          (_ctx.highlightSwitchPlayMode)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn-cancel",
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.t('common.cancel')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "btn-confirm",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.t('common.confirm')), 1)
        ]),
        (!_ctx.highlightSwitchPlayMode)
          ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(_ctx.t('dialogs.gameplay.hint')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}